common.View.create('website::layouts.main.Slider', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            loop: this.element.find('.owl-carousel').children().length > 1,
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            dots: this.element.find('.owl-carousel').data('show-dots') && this.element.find('.owl-carousel').children().length > 1,
            items: 1,
            margin: 5,
            autoHeight: true,
        });
    }
});
